const STEP_COUNT = 3;

const STEP_FIELD_NAMES = {
  1: ["property_type", "location", "radius_km"],
  2: ["price_max", "rooms_min", "rooms_max", "area_min", "area_max"],
  3: [
    "salutation",
    "first_name",
    "last_name",
    "phone",
    "email",
    "notes",
    "privacy",
  ],
};

function getStepForField(fieldName) {
  const name = fieldName.replace(/\[\]$/, "");

  for (const [step, fields] of Object.entries(STEP_FIELD_NAMES)) {
    if (fields.includes(name)) {
      return Number(step);
    }
  }

  return 3;
}

function validateAllSteps(form, stepElements) {
  for (let step = 1; step <= STEP_COUNT; step += 1) {
    const stepElement = stepElements.find(
      (element) => Number(element.dataset.searchAgentStep) === step,
    );

    if (!stepElement || !validateStep(step, stepElement)) {
      return step;
    }
  }

  return 0;
}

function getStepElements(form) {
  return [...form.querySelectorAll("[data-search-agent-step]")];
}

function getCurrentStep(form) {
  return Number(form.dataset.searchAgentCurrentStep || "1");
}

function setCurrentStep(form, section, step) {
  form.dataset.searchAgentCurrentStep = String(step);

  section.classList.remove(
    "search-agent--step-1",
    "search-agent--step-2",
    "search-agent--step-3",
  );
  section.classList.add(`search-agent--step-${step}`);

  getStepElements(form).forEach((element) => {
    const elementStep = Number(element.dataset.searchAgentStep);
    const isActive = elementStep === step;

    element.classList.toggle("is-active", isActive);
    element.hidden = !isActive;
  });

  const current = section.querySelector("[data-search-agent-current]");

  if (current) {
    current.textContent = String(step);
  }

  clearFeedback(section);
}

function clearFieldErrors(stepElement) {
  stepElement
    .querySelectorAll(".search-agent__field.is-invalid")
    .forEach((field) => {
      field.classList.remove("is-invalid");
    });
}

function markInvalid(field) {
  if (field) {
    field.classList.add("is-invalid");
  }
}

function getFieldWrap(element) {
  return element?.closest(".search-agent__field") ?? null;
}

function markInvalidByFieldName(form, fieldName) {
  const name = fieldName.replace(/\[\]$/, "");

  if (name === "property_type") {
    markInvalid(form.querySelector(".search-agent__field--types"));
    return;
  }

  const control =
    form.querySelector(`[name="${CSS.escape(name)}"]`) ||
    form.querySelector(`[name="${CSS.escape(name)}[]"]`);

  const wrap =
    getFieldWrap(control) ||
    form
      .querySelector(
        `.wpcf7-form-control-wrap[data-name="${CSS.escape(name)}"]`,
      )
      ?.closest(".search-agent__field");

  markInvalid(wrap);
}

function getServerValidationMessage(invalidFields, status) {
  if (
    status === "acceptance_missing" ||
    status === "unaccepted" ||
    invalidFields.some((field) => field.field === "privacy")
  ) {
    return (
      invalidFields.find((field) => field.field === "privacy")?.message ||
      "Bitte stimmen Sie der Datenschutzerklärung zu."
    );
  }

  if (invalidFields.length === 1 && invalidFields[0]?.message) {
    return invalidFields[0].message;
  }

  if (invalidFields.length > 1) {
    return "Bitte prüfen Sie die markierten Felder.";
  }

  return "Bitte prüfen Sie Ihre Eingaben.";
}

function validateStep(step, stepElement) {
  clearFieldErrors(stepElement);

  if (step === 1) {
    const propertyType = stepElement.querySelector(
      'input[name="property_type"]:checked',
    );
    const location = stepElement.querySelector('[name="location"]');
    let valid = true;

    if (!propertyType) {
      markInvalid(stepElement.querySelector(".search-agent__field--types"));
      valid = false;
    }

    if (!location?.value.trim()) {
      markInvalid(getFieldWrap(location));
      valid = false;
    }

    return valid;
  }

  if (step === 2) {
    const priceMax = stepElement.querySelector('[name="price_max"]');

    if (!priceMax?.value.trim()) {
      markInvalid(getFieldWrap(priceMax));
      return false;
    }

    return true;
  }

  if (step === 3) {
    const salutation = stepElement.querySelector('[name="salutation"]');
    const firstName = stepElement.querySelector('[name="first_name"]');
    const lastName = stepElement.querySelector('[name="last_name"]');
    const email = stepElement.querySelector('[name="email"]');
    const privacy = stepElement.querySelector('[name="privacy"]');
    let valid = true;

    if (!salutation?.value) {
      markInvalid(getFieldWrap(salutation));
      valid = false;
    }

    if (!firstName?.value.trim()) {
      markInvalid(getFieldWrap(firstName));
      valid = false;
    }

    if (!lastName?.value.trim()) {
      markInvalid(getFieldWrap(lastName));
      valid = false;
    }

    if (!email?.value.trim()) {
      markInvalid(getFieldWrap(email));
      valid = false;
    }

    if (!privacy?.checked) {
      markInvalid(getFieldWrap(privacy));
      valid = false;
    }

    return valid;
  }

  return true;
}

function showFeedback(section, message, type = "success") {
  const feedback = section.querySelector("[data-search-agent-feedback]");

  if (!feedback) {
    return;
  }

  feedback.hidden = false;
  feedback.textContent = message;
  feedback.classList.remove("is-error", "is-success");
  feedback.classList.add(type === "error" ? "is-error" : "is-success");
}

function clearFeedback(section) {
  const feedback = section.querySelector("[data-search-agent-feedback]");

  if (!feedback) {
    return;
  }

  feedback.hidden = true;
  feedback.textContent = "";
  feedback.classList.remove("is-error", "is-success");
}

function showSuccessState(section) {
  const bodyInner = section.querySelector(".search-agent__body-inner");

  if (bodyInner) {
    bodyInner.style.minHeight = `${bodyInner.offsetHeight}px`;
  }

  section.classList.add("search-agent--success");
  clearFeedback(section);

  const success = section.querySelector("[data-search-agent-success]");

  if (!success) {
    return;
  }

  success.hidden = false;

  window.requestAnimationFrame(() => {
    success.scrollIntoView({ behavior: "smooth", block: "center" });
  });
}

function syncTypeFilters(stepElement) {
  stepElement
    .querySelectorAll(
      ".search-agent__type-label, .search-agent__type-filters .wpcf7-list-item label",
    )
    .forEach((label) => {
      const input = label.querySelector('input[name="property_type"]');
      label.classList.toggle("is-active", Boolean(input?.checked));
    });
}

function initTypeFilters(stepElement) {
  stepElement
    .querySelectorAll(".search-agent__type-filters .wpcf7-list-item label")
    .forEach((label) => {
      label.classList.add(
        "button",
        "category-filters__button",
        "search-agent__type-label",
      );
    });

  stepElement
    .querySelectorAll('input[name="property_type"]')
    .forEach((input) => {
      input.addEventListener("change", () => {
        syncTypeFilters(stepElement);
        clearFieldErrors(stepElement);
      });
    });

  syncTypeFilters(stepElement);
}

function initSearchAgent(section) {
  if (section.dataset.searchAgentInit === "true") {
    return;
  }

  const form = section.querySelector("form.search-agent__form");

  if (!form) {
    return;
  }

  section.dataset.searchAgentInit = "true";

  const stepElements = getStepElements(form);
  const stepOne = stepElements.find(
    (element) => Number(element.dataset.searchAgentStep) === 1,
  );

  if (stepOne) {
    initTypeFilters(stepOne);
  }

  setCurrentStep(form, section, 1);

  form.addEventListener("input", (event) => {
    getFieldWrap(event.target)?.classList.remove("is-invalid");
  });

  form.addEventListener("change", (event) => {
    getFieldWrap(event.target)?.classList.remove("is-invalid");
  });

  form.querySelectorAll("[data-search-agent-next]").forEach((button) => {
    button.addEventListener("click", () => {
      const currentStep = getCurrentStep(form);
      const stepElement = stepElements.find(
        (element) => Number(element.dataset.searchAgentStep) === currentStep,
      );

      if (!stepElement || !validateStep(currentStep, stepElement)) {
        showFeedback(
          section,
          "Bitte füllen Sie alle Pflichtfelder aus.",
          "error",
        );
        return;
      }

      if (currentStep < STEP_COUNT) {
        setCurrentStep(form, section, currentStep + 1);
      }
    });
  });

  form.querySelectorAll("[data-search-agent-prev]").forEach((button) => {
    button.addEventListener("click", () => {
      const currentStep = getCurrentStep(form);

      if (currentStep > 1) {
        setCurrentStep(form, section, currentStep - 1);
      }
    });
  });

  form.addEventListener("submit", (event) => {
    const currentStep = getCurrentStep(form);

    if (currentStep !== STEP_COUNT) {
      event.preventDefault();
      return;
    }

    const failedStep = validateAllSteps(form, stepElements);

    if (failedStep) {
      event.preventDefault();
      setCurrentStep(form, section, failedStep);
      showFeedback(
        section,
        "Bitte füllen Sie alle Pflichtfelder aus.",
        "error",
      );
    }
  });
}

function handleCf7SectionEvent(event) {
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  const section = form.closest("[data-search-agent]");

  if (!section) {
    return;
  }

  const status = event.detail?.status;
  const apiStatus = event.detail?.apiResponse?.status;

  if (status === "mail_sent" || apiStatus === "mail_sent") {
    showSuccessState(section);
    return;
  }

  if (
    status === "validation_failed" ||
    status === "acceptance_missing" ||
    status === "invalid" ||
    status === "unaccepted" ||
    apiStatus === "validation_failed" ||
    apiStatus === "acceptance_missing"
  ) {
    const invalidFields = event.detail?.apiResponse?.invalid_fields ?? [];
    const firstInvalidField = invalidFields[0]?.field;
    const stepElements = getStepElements(form);
    const failedStep = firstInvalidField
      ? getStepForField(firstInvalidField)
      : getCurrentStep(form);
    const resolvedStatus = apiStatus || status;

    stepElements.forEach(clearFieldErrors);
    setCurrentStep(form, section, failedStep);
    invalidFields.forEach((field) => {
      if (field?.field) {
        markInvalidByFieldName(form, field.field);
      }
    });

    showFeedback(
      section,
      getServerValidationMessage(invalidFields, resolvedStatus),
      "error",
    );

    window.requestAnimationFrame(() => {
      form
        .querySelector(".search-agent__field.is-invalid")
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    return;
  }

  if (status === "mail_failed" || apiStatus === "mail_failed") {
    showFeedback(
      section,
      "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "error",
    );
  }
}

document.querySelectorAll("[data-search-agent]").forEach(initSearchAgent);

document.addEventListener("wpcf7submit", handleCf7SectionEvent);

document.addEventListener("wpcf7init", (event) => {
  const section = event.target?.closest?.("[data-search-agent]");

  if (section) {
    initSearchAgent(section);
  }
});
